import React from "react";


class Test extends React.Component{
    constructor(props){
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }

    changeInputValue= () =>{
        console.log(this.refs.username.value);
    };
    render(){
        return <div>
            <input type="text" ref="username" onChange={this.changeInputValue}/>
        </div>
    }

}
export default Test;


// WEBPACK FOOTER //
// ./src/page/React+React-router4.x+Ant Design+Flux视频教程--【IT营大地】/index.js